<script>
	import { goto } from '$app/navigation';
	import { PAGES } from '$lib/utils/constants';
	import { app } from '$lib/stores/app/store';
	import { logout } from '$lib/stores/user/action';

	export let showLogin = true;
	export let showLogOut = true;
	export let showSignUp = true;

	let content = {
		loginBtnTxt: 'Log In',
		logOutBtnTxt: 'Log Out',
		signUpBtnTxt: 'Sign Up'
	};

	if ($app.meta.localeCode == 'es-US') {
		content = {
			loginBtnTxt: 'Conectarse',
			logOutBtnTxt: 'Desconectarse',
			signUpBtnTxt: 'Registrarse'
		};
	}

	function handleLogin() {
		goto(PAGES.INTERNAL.LOGIN);
	}

	async function handleLogOut() {
		await logout({ meta: $app.meta });
	}

	function handleSignup() {
		goto(PAGES.INTERNAL.PROSPECT_REGISTER);
	}
</script>

<div
	class="absolute top-0 flex h-[6.2rem] w-full flex-col items-center text-white sm:h-[11.6rem] md:h-[14.4rem] lg:h-[19.3rem] xl:h-[29rem]"
>
	<div
		class="z-[1] mt-[0.7rem] flex w-full max-w-[97%] flex-col sm:mt-[2.5rem] lg:max-w-[142rem] xl:mt-[5rem] xl:max-w-[142rem]"
	>
		<nav class="flex h-[2.2rem] items-center justify-end gap-[0.8rem] self-end">
			{#if showLogin}
				<button class="btn-secondary-blue" on:click={handleLogin}>{content.loginBtnTxt}</button>
			{/if}
			{#if showLogOut}
				<button class="btn-secondary-blue" on:click={handleLogOut}>{content.logOutBtnTxt}</button>
			{/if}
			{#if showSignUp}
				<button class="btn-secondary-red" on:click={handleSignup}>{content.signUpBtnTxt}</button>
			{/if}
		</nav>
	</div>
</div>
